import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { fetchGrantPlans } from '@/api/grant/grant';
import _ from 'lodash';
import { PlanNormal, GrantType, PlanType } from '@/common/permission';
// import { UNLIMITED } from '../config'
import { PlanScope } from '@/common/permission';

export default {
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    },
    // 是否显示充值A餐、充值B餐
    isShowPlanAB: {
      type: Boolean,
      default: true
    },
    // 入口是升级套餐弹窗
    isShowUpgradeDialog: {
      type: Boolean,
      default: false
    }
  },
  // watch: {
  //   'formValue.grant_type'() {
  //     // eslint-disable-next-line vue/no-mutating-props
  //     this.formValue.plan_id = ''
  //   },
  // },
  data: function data() {
    return {
      planList: []
    };
  },

  computed: {
    planTypeList: function planTypeList() {
      var _this = this;

      // 升级套餐弹窗内的套餐选项根据反向映射表过滤
      if (this.isShowUpgradeDialog) {
        return this.planList.filter(function (t) {
          return t.up_ids && t.up_ids.indexOf(_this.authorizeInfo.plan_id) !== -1;
        });
      }
      return this.planList.filter(function (t) {
        return t.type === _this.formValue.type;
      });
    }
  },
  methods: {
    getPlanList: function getPlanList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchGrantPlans({
                  grant_type: _this2.formValue.grant_type,
                  enabled: 1 // 可用套餐
                });

              case 2:
                res = _context.sent;

                // A餐、B餐为中小套餐，其他正式套餐不可升级A餐、B餐
                if (_.get(res, 'data.data').length) {
                  data = _this2.isShowPlanAB ? _.get(res, 'data.data') : _.get(res, 'data.data').filter(function (t) {
                    return t.id !== PlanNormal.planA && t.id !== PlanNormal.planB;
                  });


                  _this2.planList = data.map(function (item) {
                    return _extends({}, item, {
                      value: item.id,
                      label: item.name
                    });
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleSelect: function handleSelect(id) {
      var plan = this.planList.find(function (t) {
        return t.id === id;
      });
      if (plan) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.permissions = plan.permissions;
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.plan_scope = plan.scope !== -1 ? plan.scope : PlanScope.Playable; // scope== -1 为可选范围，填写默认值PlanScope.Playable
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.isEdit = plan.id === PlanNormal.planA || plan.id === PlanNormal.planB; // 充值A餐、充值B餐
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.days = this.formValue.isEdit ? 365 : '';
        if (this.formValue.type === PlanType.Recharge) {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.days = 365 * 10;
          // this.formValue.days = UNLIMITED
        } else if (this.formValue.type === PlanType.Ration) {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.days = 365;
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.revenue = this.formValue.isEdit ? plan.price : '';
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.reset_day = plan.reset_day;
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.online = plan.settings.online.amount;

        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.download_push = plan.settings.download_push ? plan.settings.download_push.amount : '';

        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.render_video = plan.settings.render_video ? plan.settings.render_video.amount : '';

        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.mtg_charge = plan.scope === 1 || plan.scope === 3 ? plan.mtg_charge : '';

        if (this.formValue.grant_type === GrantType.Trial && (plan.scope === 1 || plan.scope === 3)) {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.channel_ids = [21];
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.disabledChannel = true;
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.is_all_channel = false;
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.channel_ids = [];
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.disabledChannel = false;
          // eslint-disable-next-line vue/no-mutating-props
          this.formValue.is_all_channel = true;
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.video_credits = plan.settings.video_credits ? plan.settings.video_credits.amount : 0;
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.change_keys = plan.change_keys.split(',').filter(function (t) {
          return t !== '';
        });
      }
    }
  }
};